import React from 'react'

import Voitot from './component/voitot'

import { updatePalikka, AddToValue, Palkki } from './component/palkki'

function getRotationAngle(target) {
    const obj = window.getComputedStyle(target, null)
    const matrix =
        obj.getPropertyValue('-webkit-transform') ||
        obj.getPropertyValue('-moz-transform') ||
        obj.getPropertyValue('-ms-transform') ||
        obj.getPropertyValue('-o-transform') ||
        obj.getPropertyValue('transform')

    let angle = 0

    if (matrix !== 'none') {
        const values = matrix
            .split('(')[1]
            .split(')')[0]
            .split(',')
        const a = values[0]
        const b = values[1]
        angle = Math.round(Math.atan2(b, a) * (180 / Math.PI))
    }
    angle = angle < 0 ? (angle += 360) : angle

    return 360 - angle
}

class FortuneWheel extends React.Component {
    state = {
        name: 'circle',
        hpBar: 'hpbar'
    }

    startRotation = () => {
        const rotationTime = Math.random() * this.props.oneFullRotationTime + this.props.extraRotationCount * this.props.oneFullRotationTime

        this.setState({
            name: 'circle start-rotate'
        })
        setTimeout(() => {
            this.setState({
                name: 'circle start-rotate stop-rotate'
            })
            AddToValue(12)
            const prize = this.props.prizes[Math.floor(getRotationAngle(document.getElementById('rotator')) / 45)]
            this.props.onSelection(prize)
        }, rotationTime)
    }
    render() {
        return (
            <div className="wheel-of-fortune">
                <h1>Wheel of Fortune!</h1>
                <h2>Spin the wheel!</h2>
                <section className="glassBG">
                    <div id="pointer" className="pointer"></div>
                    <div className={this.state.name} id={'rotator'}>
                        <Voitot prizes={this.props.prizes}></Voitot>
                    </div>
                    {this.props.active && (
                        <button className="spinny" onClick={this.startRotation}>
                            Spin!
                        </button>
                    )}
                    <Palkki />
                </section>
            </div>
        )
    }
}

export default FortuneWheel
